//this is base repository which is not for component specific but application specific

import Cookies from "js-cookie";

//Access Token
export const jwtToken = Cookies.get("jwt_token");

//User Login Reusable variable
export const UserName = Cookies.get("UserLogin");

//User Role
export const LoggedUserRole = Cookies.get("Role");

//storing Url in a const for simplify usage
export const BaseUrl = `${process.env.REACT_APP_BASE_URL}`;

//Http request config object for json objects
export const JsonConfig = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${jwtToken}`,
  },

};

//Http request config object for json objects
export const StringConfig = {
  headers: {
    "Content-Type": "text/plain",
    // Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${jwtToken}`,
  },
};

//Http request config object for form objects
export const FormConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${jwtToken}`,
  },
};